import { TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, BASE_PATH_API } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'functions/storageBase64';

//post enviar OcrIncode
export async function postOcrIncode(data) {

    const access_token = decodeStorage('access_token')

    let apiURL;
    
    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-claro-shop-incode/obtenerOCR?token=${data.token}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-claro-shop-incode/obtenerOCR?token=${data.token}`
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            console.log("postOcrIncode:",data);
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            return {
                'headers': '',
                'statusCode': error?.request?.status,
                'data': error?.response?.data,
                'error': error?.response?.data?.codMen
            }
        })
}
